import type {
  LinkableDlnItemsLookupParams,
  LinkableDlnItemsSelection,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  zodLinkableDlnItemsSelectionQueryParamsSchema,
  zodLinkableDlnItemsSelectionSchema,
} from './validations';

/**
 * Fetches every delivery note line the article search matches, as link
 * targets, to select them all without paging.
 *
 * @param params - Invoice, line item and the search filters.
 * @param options - Request options supplied by TanStack Query.
 * @returns The targets with their count and summed quantity.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/select_linkable_dln_items_invoices__invoice_id__line_items__line_item_id__linkable_dln_items_selection_get
 */
export async function fetchLinkableDlnItemsSelection(
  { filters, invoiceId, lineItemId }: LinkableDlnItemsLookupParams,
  options?: KyRequestOptions,
): Promise<LinkableDlnItemsSelection> {
  return vestigasApi
    .get(
      ENDPOINT.INVOICE.GET_LINKABLE_DLN_ITEMS_SELECTION(invoiceId, lineItemId),
      {
        ...options,
        searchParams: filters,
        validate: {
          ...options?.validate,
          response: zodLinkableDlnItemsSelectionSchema,
          searchParams: zodLinkableDlnItemsSelectionQueryParamsSchema.transform(
            (data) => withoutObjectKeysWhereValueIs(data, [undefined, '']),
          ),
        },
      },
    )
    .json<LinkableDlnItemsSelection>();
}
